export const EVENT_NAME = {
  LOGIN_WALL: "Open",
  PILL_CLICKED: "Pill Selected",
  ADD_FUNDS_CLICKED: "Add Funds Clicked"
};
